export enum ESsPlayerFreespinStage {
  ACTIVATED = 'activated',
  EXPIRED = 'expired',
  ISSUED = 'issued',
  CANCELED = 'canceled',
  FINISHED = 'finished',
}

export enum ESsPlayerBonusStage {
  LOST = 'lost',
  WAIT = 'wait',
  HANDLE_BETS = 'handle_bets',
  EXPIRED = 'expired',
  ISSUED = 'issued',
  CANCELED = 'canceled',
  WAGER_DONE = 'wagerDone',
}

interface ISsPlayerFreespinsGamesInfo {
  frontend_url: string; // "blue-beard"
  identifier: string; // "belatra/BlueBeard"
  title: string; // "Blue Beard"
}

export interface ISsPlayerBonuses {
  id: number; // 406823
  stage: ESsPlayerBonusStage; // "canceled"
  activatable: boolean; // false
  activatable_until?: any; // null
  amount_cents: number; // 100000
  amount_wager_cents: number; // 180000
  amount_wager_requirement_cents: number; // 10000000000
  cancelable: boolean; // false
  created_at: string; // "2021-04-22T08:20:38.559Z"
  currency: string; // "BTC"
  strategy: string; // "personal"
  title: string; // "test4"
  valid_until: string | null; // "2021-04-23T00:00:00.000Z"
}

export interface ISsPlayerFreespins {
  id: number; // 406823
  stage: ESsPlayerFreespinStage; // "canceled"
  activatable: boolean; // false
  activatable_until?: any; // null
  amount_cents: number; // 100000
  amount_wager_cents: number; // 180000
  amount_wager_requirement_cents: number; // 10000000000
  cancelable: boolean; // false
  created_at: string; // "2021-04-22T08:20:38.559Z"
  currency: string; // "BTC"
  freespins_performed?: any; // null
  freespins_total?: number; // 2
  bet_level?: number | null; // Determines the bet level of freespin. Currently only supported by netent and softswiss providers
  provider?: string; // "platipus"
  games?: string[]; // Game list for which freespin are available
  games_info?: ISsPlayerFreespinsGamesInfo[]; // games info for freespins bonuses
  activation_path?: any; // Deprecated field
  strategy?: string; // "personal"
  title: string; // "test4"
  valid_until: string | null; // "2021-04-23T00:00:00.000Z"
  activation_condition?: string | null; //  Shows the context which freespin cannot be activated
}
